import React from 'react'
import debounce from 'lodash/debounce'

export default class Title extends React.Component {
  state = {
    value: this.props.value,
    width: 'auto',
    defaultWidth: 'auto',
  }

  componentDidMount() {
    this.setState({
      width: this.text.scrollWidth,
      defaultWidth: this.text.scrollWidth,
    })
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      this.handleChange({ target: { value: nextProps.value } })
    }
  }

  handleUpdate = debounce(input => {
    const value = input === '' ? this.props.category : input
    const width = input === '' ? this.state.defaultWidth : this.state.width
    this.setState(
      { value, width },
      () => this.props.editTitle && this.props.editTitle(value)
    )
  }, 1000)

  handleChange = e => {
    const input = e.target.value.replace(/\s\s+/g, ' ')
    this.setState({ value: input }, () => {
      this.setState({ width: this.text.scrollWidth })
      this.handleUpdate(input)
    })
  }

  render() {
    return (
      <div>
        <span className="title__measure" ref={el => (this.text = el)}>
          {this.state.value}
        </span>
        <input
          className="title"
          type="text"
          value={this.state.value}
          onChange={this.handleChange}
          style={{ width: Math.max(this.state.width + 4, 20) || 20 }}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Title.js